import axios from 'axios';
import { incrementBusyIndicator, decrementBusyIndicator } from '../domain/busyIndicatorSlice.js';
import apiMap from './apiMap.js'
import { getToken, saveTokens } from '../domain/loginSlice.js';
import { logout } from '../domain/loginSlice.js';
const SERVER_URL =import.meta.env.VITE_SERVER_API_URL;

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const api = async ({ type, data, disableBI, disableEH, params = '' }) => {
    try {
        !!!disableBI && incrementBusyIndicator();

        const res = await axios({
            url: `${SERVER_URL}${apiMap[type].url + params}`,
            data,
            method: apiMap[type].method.toLowerCase(),
            headers: {
                authorization: getToken('accessToken')
            }
        })

        !!!disableBI && decrementBusyIndicator();

        return res.data;

    } catch (err) {
        !!!disableBI && decrementBusyIndicator();

        try {
            if (err.response.status !== 403) throw err

            const res = await api({
                type: 'refreshToken',
                data: {
                    refreshToken: getToken('refreshToken')
                },
                disableBI: true
            });

            saveTokens(res);
            const res2 = await api({ type, data, disableBI });
            return res2;

        } catch (err) {
            if (disableEH && err.response.status === 401) {
                logout();
            } else if (!disableEH) {
                if (err.response.status === 401) {
                    window.location = "/";
                }
            }

        }
    }

}


export const getEdgeResponse = async (responseId, tries = 80) => {
    console.log('tries, ',tries )
    try {
        let res = false;

        for (let i = 0; ((i <= tries) && !res); i++) {
            res = await api({
                type: 'getEdgeResponse',
                data: {
                    responseId
                }
            });
            if (res) return res;
            await sleep(1000);
        }

        return false;
    } catch (err) {
        return false;
    }
}
